var React = require('react');

function IntroWave (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#A0CFC6","d":"M420 40c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-22.091-17.909-40-40-40s-40 17.909-40 40c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-22.091-17.909-40-40-40s-40 17.909-40 40c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-22.091-17.909-40-40-40S60 17.909 60 40c0 11.046-8.954 20-20 20s-20-8.954-20-20H0c0 22.091 17.909 40 40 40s40-17.909 40-40c0-11.046 8.954-20 20-20 11.045 0 20 8.954 20 20 0 22.091 17.909 40 40 40s40-17.909 40-40c0-11.046 8.954-20 20-20 11.045 0 20 8.954 20 20 0 22.091 17.909 40 40 40s40-17.909 40-40c0-11.046 8.954-20 20-20 11.045 0 20 8.954 20 20 0 22.091 17.909 40 40 40s40-17.909 40-40h-20z"}));
}

IntroWave.defaultProps = {"viewBox":"0 0 440 80","width":"440","height":"80"};

module.exports = IntroWave;

IntroWave.default = IntroWave;
